<script setup></script>

<template>
  <svg fill="currentColor" width="13" height="21" viewBox="0 0 13 21" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.0875 0.75L0 3.8375L6.825 10.5L0 17.1625L3.0875 20.25L13 10.5L3.0875 0.75Z" />
  </svg>
</template>
